import { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Box, Tooltip, TextField, IconButton, InputAdornment } from '@mui/material';
import Iconify from '../../../../../reusable-components/iconify';

IntacctConnectionForm.propTypes = {
  setFormValue: PropTypes.func,
  formValue: PropTypes.object,
  isInitalAdd: PropTypes.bool
};

export default function IntacctConnectionForm({ formValue, setFormValue, isInitalAdd }) {
  const [showPassword, setShowPassword] = useState(false);

  return <>
    <Tooltip title="The company id used to authenticate to Intacct." arrow placement="left">
      <Box>
        <Typography variant="subtitle1">
          Company Id*
        </Typography>
        <TextField
          size="small"
          value={formValue.companyId ?? ""}
          onChange={(e) => setFormValue(value => ({ ...value, companyId: e.target.value }))}
          fullWidth
        />
      </Box>
    </Tooltip>
    <Tooltip title="The user id used to authenticate to Intacct." arrow placement="left">
      <Box>
        <Typography variant="subtitle1">
          User Id*
        </Typography>
        <TextField
          id="user"
          size="small"
          value={formValue.userId ?? ""}
          onChange={(e) => setFormValue(value => ({ ...value, userId: e.target.value }))}
          fullWidth
        />
      </Box>
    </Tooltip>
    <Box>
      <Typography variant="subtitle1">
        User Password*
      </Typography>
      <TextField
        size="small"
        fullWidth
        placeholder="Enter password"
        sx={showPassword ? {} : { "input": { "-webkit-text-security": "disc !important" } }}
        value={formValue.password ?? (!showPassword && !isInitalAdd && formValue.id ? "**********" : "")}
        autoComplete="off"
        onChange={(e) => setFormValue(value => ({ ...value, password: e.target.value }))}
        InputProps={{
          autoComplete: "off",
          startAdornment: <InputAdornment position="start">
            <Iconify icon="eva:lock-outline" />
          </InputAdornment>,
          endAdornment: <InputAdornment position="end">
            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
              <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
            </IconButton>
          </InputAdornment>
        }}
      />
    </Box>
  </>;
}
